import { TypographyXSmall } from '@/components/ui/typography.jsx'

export const FormBlock = ({ label, required, children, customError, cta, className = '' }) => {
    return (

        <div className={`flex relative flex-col gap-2 ${className}`}>
            {
                cta ? <div className="absolute right-0 top-[-5px]">{cta}</div> : null
            }
            {
                label && (
                    <TypographyXSmall className="text-sm font-light text-muted-foreground">
                        {required && <span className="text-error-400 mr-1">*</span>}
                        {label}
                    </TypographyXSmall>
                )
            }
            {
                children
            }
            {
                customError ? <TypographyXSmall className="text-error-400 pl-1">{customError}</TypographyXSmall> : null
            }
        </div>
    )
}
